import { PureComponent } from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Header from '../components/Header';
import FreeTrialHeader from '../components/FreeTrialHeader';
import Navigation from '../components/Navigation';
import { ErrorBoundary } from '../components/common';
import PolicyAcceptanceModal from '../components/PolicyAcceptanceModal';
import BillingModal from '../components/settings/BillingModals';
import BillingModalHelper from '../components/settings/BillingModalHelper';

class Layout extends PureComponent {
  billingModalProps = BillingModalHelper();

  render() {
    const {
      pageHeading,
      bredCrumbLinks,
      children,
      userRole,
      accountStatus,
      policyStatus,
      plan,
    } = this.props;
    document.title = pageHeading.preTitle;
    const url = new URL(window.location.href);
    const isFreeTrail =
      plan &&
      plan !== null &&
      plan.toLowerCase().includes('trial') &&
      accountStatus !== 'cancel';
    return (
      <>
        <Navigation category={pageHeading.preTitle} />
        {userRole === 'creator' &&
          accountStatus === 'cancel' &&
          url.pathname.split('/')[2] !== 'account-closed' &&
          url.pathname.split('/')[2] !== 'billing' &&
          this.billingModalProps.title && (
            <BillingModal modalProps={this.billingModalProps} />
          )}

        {isFreeTrail && userRole === 'creator' && <FreeTrialHeader />}
        <div
          className={
            isFreeTrail && userRole === 'creator'
              ? 'main-content free-trial'
              : 'main-content'
          }
        >
          <Header pageHeading={pageHeading} bredCrumbLinks={bredCrumbLinks} />
          {/* Trigger Policy Acceptance request model if there is any change in policy or terms */}
          {!policyStatus && <PolicyAcceptanceModal />}
          {(accountStatus === 'cancel' &&
            (url.pathname.split('/')[2] === 'billing' ||
              url.pathname.split('/')[2] === 'account-closed')) ||
          accountStatus !== 'cancel' ? (
            <Container fluid className="pt-4 content-wrapper">
              <ErrorBoundary>{children}</ErrorBoundary>
            </Container>
          ) : (
            ''
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { userReducer, billingReducer } = state;
  return {
    userRole: userReducer.role,
    accountStatus: billingReducer.accountStatus,
    policyStatus: userReducer.policyAcceptanceStatus,
    plan: userReducer.subscription.currentPlan,
  };
};

Layout.propTypes = {
  userRole: PropTypes.string,
  accountStatus: PropTypes.string,
  pageHeading: PropTypes.object,
  bredCrumbLinks: PropTypes.array,
  children: PropTypes.any,
  policyStatus: PropTypes.bool,
  plan: PropTypes.string,
};

export default connect(mapStateToProps)(Layout);
